var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Mz=require("ttag");module.exports=$CLJS.Mz;